'use client';
import { useEffect } from 'react';
import { handleSignOut } from './nestingale_auth';
import { CgProfile, CgLogOff } from 'react-icons/cg';
import { useUserSession } from '@/app/lib/context/UserSessionContext';

const IS_BROWSER = typeof window !== 'undefined';

function getDisplayName(session: { name?: string; email?: string } | null): string | null {
    if (!session) return null;
    return session.name || session.email || null;
}

export default function NestProfile() {
    const { sessionInfo, setSessionInfo, isLoadingSession } = useUserSession();

    // The context provider now self-initialises the session on mount.
    // Redirection to login is handled by ProtectedRoute for protected pages.
    // Public pages should allow guests.

    const handleSignOutLocal = async (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        try {
            await handleSignOut();
            setSessionInfo({
                session: null,
                providerType: '',
                isSessionValid: false,
                userType: undefined,
            });
        } catch (error) {
            console.error('[NestProfile] Sign-out error:', error);
        }
    };

    const displayName = getDisplayName(sessionInfo?.session ?? null);

    return (
        <nav className="flex mr-[30px] justify-end flex-grow items-end pb-1">
            <div>
                {sessionInfo?.isSessionValid && displayName ? (
                    <div className="flex items-center space-x-3">
                        <span className="ml-[20px] text-[14px] text-gray-500">
                            <CgProfile size={24} />
                        </span>
                        <span className="text-[14px]">Welcome, {displayName}</span>
                        <span
                            className="text-[14px] cursor-pointer"
                            role="button"
                            aria-label="Sign out"
                            onClick={handleSignOutLocal}
                        >
                            <CgLogOff size={24} />
                        </span>
                    </div>
                ) : (
                    <span className="ml-[20px] text-[14px] text-gray-500">
                        <CgProfile size={24} />
                    </span>
                )}
            </div>
        </nav>
    );
}
